import React from 'react';
import { Table, Tag } from 'antd';
import { useTranslation } from '../../../../utils/useI18n';

const COLORS = { primary: '#00d4ff', solar: '#f4c542', grid: '#3a8dde' };
const fmt0 = v => (v != null && !isNaN(v) ? (typeof v === 'number' ? v.toFixed(2) : v) : '-');
const fmtTime = t => t ? new Date(t).toLocaleString() : '-';

export default function LiquidCoolTable({ data }) {
  const { t } = useTranslation();

  const columns = [
    { title: 'sn', dataIndex: 'sn', key: 'sn', render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span>, width: 130 },
    { title: t('cloud.deviceNo'), dataIndex: 'global_no', key: 'global_no', render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span>, width: 110 },
    { title: t('cloud.name'), dataIndex: 'name', key: 'name', render: (n, r) => n || r.global_no || '-', width: 130 },
    { title: t('cloud.online'), dataIndex: 'online', key: 'online', render: v => <Tag color={v === 1 ? 'green' : 'default'}>{v === 1 ? t('status.online') : t('status.offline')}</Tag>, width: 80 },
    { title: t('cloud.runStatus'), dataIndex: 'run_status', key: 'run_status', render: v => v != null ? <Tag>{v}</Tag> : '-', width: 90 },
    { title: t('cloud.dataQuality'), dataIndex: 'data_quality', key: 'data_quality', render: v => v || '-', width: 100 },
    { title: t('cloud.runState'), dataIndex: 'run_state', key: 'run_state', render: v => v ?? '-', width: 80 },
    { title: 'outlet_water_temp_c', dataIndex: 'outlet_water_temp_c', key: 'outlet_water_temp_c', render: v => <span style={{ color: COLORS.solar }}>{fmt0(v)}</span>, width: 140 },
    { title: 'supply_water_temp_c', dataIndex: 'supply_water_temp_c', key: 'supply_water_temp_c', render: v => <span style={{ color: COLORS.solar }}>{fmt0(v)}</span>, width: 140 },
    { title: 'outlet_pressure_mpa', dataIndex: 'outlet_pressure_mpa', key: 'outlet_pressure_mpa', render: fmt0, width: 140 },
    { title: 'supply_pressure_mpa', dataIndex: 'supply_pressure_mpa', key: 'supply_pressure_mpa', render: fmt0, width: 140 },
    { title: 'return_pressure_mpa', dataIndex: 'return_pressure_mpa', key: 'return_pressure_mpa', render: fmt0, width: 140 },
    { title: t('cloud.recordTime'), dataIndex: 'recorded_at', key: 'recorded_at', render: fmtTime, width: 160 },
  ];

  if (!data || data.length === 0) return null;

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ color: COLORS.primary, fontSize: 14, fontWeight: 600, marginBottom: 8, borderLeft: '3px solid #3a8dde', paddingLeft: 8 }}>
        {t('cloud.telemetryLiquidCool')} {data.length} {t('cloud.telemetryRecords')}
      </div>
      <Table columns={columns} dataSource={data} rowKey="id" size="small" pagination={{ pageSize: 5, showSizeChanger: false }} style={{ background: 'transparent' }} scroll={{ x: 2000 }} tableLayout="fixed" />
    </div>
  );
}
